import type { Blocker, History, Transition } from 'history';
import * as React from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

// Code copied from suggestions at https://github.com/remix-run/react-router/issues/8139

export default function useBlocker(blocker: Blocker, when = true): void {
	const navigator = React.useContext(UNSAFE_NavigationContext)
		.navigator as History;

	React.useEffect(() => {
		if (!when) return;

		const unblock = navigator.block((tx: Transition) => {
			const autoUnblockingTx = {
				...tx,
				retry() {
					// Automatically unblock the transition so it can play all the way
					// through before retrying it. TODO: Figure out how to re-enable
					// this block if the transition is cancelled for some reason.
					unblock();
					tx.retry();
				},
			};

			blocker(autoUnblockingTx);
		});

		return unblock;
	}, [navigator, blocker, when]);
}
